export default __webpack_public_path__ + "static/media/home-after-cleaning.0a59c6d4.jpeg";